import FreshFundOGImage from '../images/og/social-card.jpg';

export const APPLY_NOW_LINK = 'https://airtable.com/shr6boLeLa0F0v4lU/';

export const DEFAULT_METADATA = {
  title: 'Fresh Fund | Supporting young Black founders',
  meta: {
    image: FreshFundOGImage,
    description:
      'The Courier Fresh Fund is a US $150,000 fund of cash grants for young Black founders in the UK and US who have great ideas to start or grow a business.',
    title: 'Fresh Fund | Supporting young Black founders',
    twitterCard: 'summary_large_image',
  },
};
